import { render, staticRenderFns } from "./deck.vue?vue&type=template&id=da4fa806&scoped=true&"
import script from "./deck.vue?vue&type=script&lang=js&"
export * from "./deck.vue?vue&type=script&lang=js&"
import style0 from "./deck.vue?vue&type=style&index=0&id=da4fa806&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4fa806",
  null
  
)

export default component.exports